/**
 * Get the browser's current origin (scheme + host + port).
 * Defensive: returns empty string if window, location, or origin is unavailable.
 */
export function getBaseUrl() {
    try {
        if (typeof window !== 'undefined' && window.location && window.location.origin) {
            return window.location.origin;
        }
        // Fallback: reconstruct from protocol and host if origin is missing
        if (typeof window !== 'undefined' && window.location && window.location.protocol && window.location.host) {
            return window.location.protocol + '//' + window.location.host;
        }
    } catch (e) {
        // Silently catch any errors and return empty string
    }
    return '';
}

/**
 * Build the public profile URL from the base URL and friendly URL.
 * Returns the exact URL that the public profile link will use.
 * @param {string} baseUrl - The base URL (origin)
 * @param {string} friendlyUrl - The friendly URL slug
 * @returns {string} The full public profile URL
 */
export function buildPublicProfileUrl(baseUrl, friendlyUrl) {
    if (!baseUrl || !friendlyUrl) {
        return '';
    }
    return baseUrl + '/' + encodeURIComponent(friendlyUrl);
}
